import { render } from "./contenttoggle.vue?vue&type=template&id=84a88fb2"
import script from "./contenttoggle.vue?vue&type=script&lang=js"
export * from "./contenttoggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__